import { Component } from '@angular/core';

@Component({
  selector: 'app-redirect',
  template: '<div>Redirecting...</div>',
})
export class RedirectComponent {
  constructor() {}
}
